import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'mm-ira-calculator',
  templateUrl: './ira-calculator-modal.component.html',
  styleUrls: ['./ira-calculator-modal.component.scss']
})

export class IraCalculatorComponent {
  @Input() showModal: Observable<boolean>;
  @Output() showIRACalcModal = new EventEmitter<boolean>();
  modal: EverestModal;
  destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnInit(): void {
    this.modal = document.getElementById('ira-calculator-modal') as EverestModal;
    this.showModal.pipe(takeUntil(this.destroy$)).subscribe((show) => {
      if (show) this.modal.showModal();
      document.documentElement.style.overflow = 'hidden'; //hide second vertical scroll bar
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  rmdCalcLinkClicked(): void{
    window.open("https://content.schwab.com/ira/understand-iras/ira-calculators/inherited-rmd/", '_blank');
    this.modal.hideModal();
  }

  onCloseClick(): void {
    this.modal.hideModal();
    document.documentElement.style.overflow = 'hidden'; //re-display vertical scroll bar after dismissing modal
  }
}

type EverestModal = HTMLElement & {
  showModal: () => {};
  hideModal: () => {};
};
